import { GET_DUTYTYPE } from "resources/actionTypes";


export function getDutyType(data) {

  return{
    type:  GET_DUTYTYPE.GET_DUTYTYPE_REQUESTED,
    payload: data
  };
}